import { DtRef } from '@ow/ditto-core'

export { default as Render } from './render'

const { transformer, validation } = DtRef
export { transformer, validation }
